import { render, staticRenderFns } from "./comment-dispute-history-candidate.vue?vue&type=template&id=e7df379c"
import script from "./comment-dispute-history-candidate.vue?vue&type=script&lang=js"
export * from "./comment-dispute-history-candidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports